/**
 * Validatori condivisi per input fiscali italiani.
 * Pattern e regole identici tra validazione live (onChange) e validazione submit.
 */

/** Normalizza l'input rimuovendo spazi e convertendo in maiuscolo. */
export const normalizePivaCf = (v) => (v || "").trim().toUpperCase().replace(/\s+/g, "");

/** True se la stringa "sembra" un CF persona fisica (16 caratteri alfanumerici, non solo cifre).
 *  Usato per BLOCCARE servizi disponibili solo a società di capitale (es. Bilancio Aziendale). */
export const looksLikePersonaFisicaCF = (v) => {
  const s = normalizePivaCf(v);
  return s.length === 16 && !/^\d+$/.test(s);
};

/** True se la stringa è una Partita IVA italiana valida nel formato (11 cifre numeriche).
 *  Non verifica il check digit (validazione strutturale only). */
export const isPartitaIvaItaliana = (v) => {
  const s = normalizePivaCf(v);
  return s.length === 11 && /^\d+$/.test(s);
};

/** Errore user-facing per servizi limitati a società di capitale. */
export const ERR_NO_PERSONA_FISICA =
  "Il servizio Bilancio è disponibile solo per società di capitale (SRL, SPA, SAPA). " +
  "Per persone fisiche o ditte individuali questo servizio non è applicabile.";

export const ERR_PIVA_FORMAT =
  "La Partita IVA italiana deve essere di 11 cifre numeriche.";
